import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@ziggiz/api';

const RETRYABLE_STATUSES = new Set([408, 425, 429, 500, 502, 503, 504]);
const MAX_RETRIES = 2;

/**
 * Queries throw by default so failures land in the nearest `QueryBoundary`
 * instead of being silently rendered as empty state. Opt out per-query with
 * `throwOnError: false` when a component wants to handle the error inline.
 */
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        throwOnError: true,
        retry: (failureCount, error) => {
          if (failureCount >= MAX_RETRIES) {
            return false;
          }

          return isApiError(error) ? RETRYABLE_STATUSES.has(error.status) : true;
        }
      },
      mutations: {
        retry: false
      }
    }
  });
